import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import type { ParsedTemplateVariable } from '@/components/organisms/template-variable-editor/template-variable.interface'

import { PromptTemplateContentField } from './prompt-template-content-field.atom'
import { PromptTemplateDescriptionField } from './prompt-template-description-field.atom'
import type { PromptTemplateDrawerFormSchemaType } from './prompt-template-drawer-form.schema'
import { PromptTemplateNameField } from './prompt-template-name-field.atom'

interface PromptTemplateDrawerFormProps {
  form: UseFormReturn<PromptTemplateDrawerFormSchemaType>
  isDisabled?: boolean
  onVariablesChange?: (variableList: ParsedTemplateVariable[]) => void
}

/**
 * Form fields for creating or editing a prompt template.
 */
export const PromptTemplateDrawerForm = ({
  form,
  isDisabled = false,
  onVariablesChange,
}: PromptTemplateDrawerFormProps): ReactNode => (
  <div className="prompt-template-drawer-form space-y-6">
    <PromptTemplateNameField form={form} isDisabled={isDisabled} />
    <PromptTemplateDescriptionField form={form} isDisabled={isDisabled} />
    <PromptTemplateContentField
      form={form}
      isDisabled={isDisabled}
      onVariablesChange={onVariablesChange}
    />
  </div>
)

PromptTemplateDrawerForm.displayName = 'PromptTemplateDrawerForm'
